import { TableCell } from '@material-ui/core';
import { useUserContext } from 'common/contexts/UserContext';
import { useSegment } from 'common/hooks/segment';
import StatusIcon from 'components/StatusIcon';
import _ from 'lodash';
import * as React from 'react';
import { Shift } from 'services/helpers/shift';
import WithLegendPopover from '../../../WithLegendPopover';
import Chassis from '../Chassis';
import { clockStatus, SHIFTS_REF } from '../../constants/next-appointments.constants';
import { NextAppointmentsService } from '../../services/next-appointments.service';
import { ShiftTotal } from '../ShiftTotal';

const getFormattedTimeSlot = (start_time: string, end_time: string) => {
  // BCIC-402 If appointments are after midnight, add a * before the time slot
  const isAfterMidnight = NextAppointmentsService.checkIsSlotAfterMidnight(start_time, end_time);
  return `${isAfterMidnight ? '*' : ''}${start_time.substr(0, 5)} - ${end_time.substr(0, 5)}`;
};

interface Props {
  terminalKey: string;
  terminalUrl: string;
  shift: Shift;
  status: string;
  warnings: string[];
  chassis_restrictions: string[];
  appointments?: number;
  start_time: string;
  end_time: string;
  classes: Record<string, string>;
  currentSLKey: string;
  currentContainerKey: string;
}

export const AppointmentCell: React.FC<Props> = (props) => {
  const {
    terminalKey,
    terminalUrl,
    shift,
    status,
    warnings,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    chassis_restrictions,
    appointments,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    start_time,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    end_time,
    classes,
    currentSLKey,
    currentContainerKey,
  } = props;

  const formattedTimeSlot = getFormattedTimeSlot(start_time, end_time);
  const { trackEventNoSlack } = useSegment();
  const { user } = useUserContext();

  const renderedData = (
    <div>
      <div>{formattedTimeSlot}</div>
      <ShiftTotal classes={classes} appointments={appointments} />
    </div>
  );

  // BCIC-405 Add a grey filter if there is empty restriction = CLOSED
  let className;
  let isGrey = false;

  if (status && (status === 'yes' || status === 'dual')) {
    className = shift.shift === SHIFTS_REF.shift2 ? classes.cellAppointmentsFat : classes.cell;
  } else {
    isGrey = true;
    className =
      shift.shift === SHIFTS_REF.shift2
        ? classes.cellAppointmentsGreyFat
        : classes.cellAppointmentsGrey;
  }

  return (
    <TableCell
      className={className}
      align="center"
      onClick={() => {
        NextAppointmentsService.fireGAcellClickEvent(
          currentSLKey,
          currentContainerKey,
          user,
          terminalKey,
          shift
        );

        trackEventNoSlack('Empty-appointment Cell Clicked', {
          shippingLine: currentSLKey,
          containerType: currentContainerKey,
          terminal: terminalKey,
          date: shift.day,
          shift: shift.shift,
        });

        window.open(terminalUrl);
      }}
    >
      <WithLegendPopover
        isShown
        status={status || clockStatus}
        warnings={warnings}
        formattedTimeSlot={formattedTimeSlot}
        appointments={appointments}
      >
        {status !== 'no' && renderedData}
        {currentContainerKey && (
          <StatusIcon
            status={status || clockStatus}
            warnings={warnings}
            isGrey={isGrey}
            isEmptyAppointments
          />
        )}
        {status !== 'no' && chassis_restrictions && !_.isEmpty(chassis_restrictions) && (
          <Chassis chassis_restrictions={chassis_restrictions} isGrey={isGrey} />
        )}
      </WithLegendPopover>
    </TableCell>
  );
};
